import { entries } from "lodash";
import { typedKeys } from "../lodash-extra";

export enum BookingType {
  // License
  License = "License",
  LicenseDiscount = "LicenseDiscount",
  LicenseDiscountCancellation = "LicenseDiscountCancellation",
  LicenseCancellation = "LicenseCancellation",
  LicenseCompensationAmount = "LicenseCompensationAmount",
  LicenseDiscountCompensationAmount = "LicenseDiscountCompensationAmount",
  MonthlyFloorPaidInAdvance = "MonthlyFloorPaidInAdvance",
  // Candidate
  Candidate = "Candidate",
  CandidateDiscount = "CandidateDiscount",
  CandidateDiscountCancellation = "CandidateDiscountCancellation",
  CandidateCancellation = "CandidateCancellation",
  CompensationAmount = "CompensationAmount",
  CompensationCandidateDiscount = "CompensationCandidateDiscount",
  CompensationCap = "CompensationCap",
  CompensationFloor = "CompensationFloor",
  CompensationMonthlyFloor = "CompensationMonthlyFloor",
  CompensationMonthlyFloorOverpay = "CompensationMonthlyFloorOverpay",
  CompensationCandidateByMonthlyFloor = "CompensationCandidateByMonthlyFloor",
  CompensationReplacement = "CompensationReplacement",
  CompensationContingent = "CompensationContingent",
  // Contingent
  Contingent = "Contingent",
  // Additional Features
  CandidateTransfer = "CandidateTransfer",
  // User Accounts
  UserAccount = "UserAccount",
  UserAccountCancellation = "UserAccountCancellation",
  // Services
  ServiceLingoking = "ServiceLingoking",
  ServiceBarmer = "ServiceBarmer",
  ServiceChat = "ServiceChat",
  ServiceChatCancellation = "ServiceChatCancellation",
  ServiceCvParsing = "ServiceCvParsing",
  ServiceDocuSealSigningSes = "ServiceDocuSealSigningSes",
  ServiceDocuSealSigningAes = "ServiceDocuSealSigningAes",
  ServiceDocuSealSigningQes = "ServiceDocuSealSigningQes",
  ServiceDocuSealIdVerification = "ServiceDocuSealIdVerification",
  ServiceCvParsingCancellation = "ServiceCvParsingCancellation",
  ServiceTalentPoolWebsite = "ServiceTalentPoolWebsite",
  ServiceTalentPoolWebsiteCancellation = "ServiceTalentPoolWebsiteCancellation",

  // Payment
  IncomingPayment = "IncomingPayment",
  IncomingPaymentCancellation = "IncomingPaymentCancellation",
  CreditBalanceSettlement = "CreditBalanceSettlement",
  CreditBalanceSettlementCancellation = "CreditBalanceSettlementCancellation",
  // Manual
  CreditNote = "CreditNote",
  Other = "Other",
  DailyRateBasedService = "DailyRateBasedService",
  DailyRateBasedServiceCancellation = "DailyRateBasedServiceCancellation",
  // Recurring Fee
  RecurringFee = "RecurringFee",
  RecurringFeeCancellation = "RecurringFeeCancellation",
  // Commission
  Commission = "Commission",
  CommissionCancellation = "CommissionCancellation",
}

export enum BookingTypeGroup {
  Candidate = "Candidate",
  License = "License",
  UserAccount = "UserAccount",
  Contingent = "Contingent",
  Service = "Service",
  Payment = "Payment",
  Manual = "Manual",
  AdditionalFeature = "AdditionalFeature",
  Commission = "Commission",
}

const bookingTypeGroups: Record<BookingType, BookingTypeGroup> = {
  // Candidate
  [BookingType.Candidate]: BookingTypeGroup.Candidate,
  [BookingType.CandidateDiscount]: BookingTypeGroup.Candidate,
  [BookingType.CandidateDiscountCancellation]: BookingTypeGroup.Candidate,
  [BookingType.CandidateCancellation]: BookingTypeGroup.Candidate,
  [BookingType.CompensationAmount]: BookingTypeGroup.Candidate,
  [BookingType.CompensationCandidateDiscount]: BookingTypeGroup.Candidate,
  [BookingType.CompensationCap]: BookingTypeGroup.Candidate,
  [BookingType.CompensationFloor]: BookingTypeGroup.Candidate,
  [BookingType.CompensationMonthlyFloor]: BookingTypeGroup.Candidate,
  [BookingType.CompensationMonthlyFloorOverpay]: BookingTypeGroup.Candidate,
  [BookingType.CompensationCandidateByMonthlyFloor]: BookingTypeGroup.Candidate,
  [BookingType.CompensationReplacement]: BookingTypeGroup.Candidate,
  [BookingType.CompensationContingent]: BookingTypeGroup.Candidate,
  [BookingType.Contingent]: BookingTypeGroup.Contingent,
  // License
  [BookingType.License]: BookingTypeGroup.License,
  [BookingType.LicenseDiscount]: BookingTypeGroup.License,
  [BookingType.LicenseDiscountCancellation]: BookingTypeGroup.License,
  [BookingType.LicenseCancellation]: BookingTypeGroup.License,
  [BookingType.LicenseCompensationAmount]: BookingTypeGroup.License,
  [BookingType.LicenseDiscountCompensationAmount]: BookingTypeGroup.License,
  [BookingType.MonthlyFloorPaidInAdvance]: BookingTypeGroup.License,
  // Additional Features
  [BookingType.CandidateTransfer]: BookingTypeGroup.AdditionalFeature,
  [BookingType.UserAccount]: BookingTypeGroup.UserAccount,
  [BookingType.UserAccountCancellation]: BookingTypeGroup.UserAccount,
  // Services
  [BookingType.ServiceLingoking]: BookingTypeGroup.Service,
  [BookingType.ServiceBarmer]: BookingTypeGroup.Service,
  [BookingType.ServiceChat]: BookingTypeGroup.Service,
  [BookingType.ServiceChatCancellation]: BookingTypeGroup.Service,
  [BookingType.ServiceCvParsing]: BookingTypeGroup.Service,
  [BookingType.ServiceDocuSealSigningSes]: BookingTypeGroup.Service,
  [BookingType.ServiceDocuSealSigningAes]: BookingTypeGroup.Service,
  [BookingType.ServiceDocuSealSigningQes]: BookingTypeGroup.Service,
  [BookingType.ServiceDocuSealIdVerification]: BookingTypeGroup.Service,
  [BookingType.ServiceCvParsingCancellation]: BookingTypeGroup.Service,
  [BookingType.ServiceTalentPoolWebsite]: BookingTypeGroup.Service,
  [BookingType.ServiceTalentPoolWebsiteCancellation]: BookingTypeGroup.Service,
  // Payment
  [BookingType.IncomingPayment]: BookingTypeGroup.Payment,
  [BookingType.IncomingPaymentCancellation]: BookingTypeGroup.Payment,
  [BookingType.CreditBalanceSettlement]: BookingTypeGroup.Payment,
  [BookingType.CreditBalanceSettlementCancellation]: BookingTypeGroup.Payment,
  // Manual
  [BookingType.CreditNote]: BookingTypeGroup.Manual,
  [BookingType.DailyRateBasedService]: BookingTypeGroup.Manual,
  [BookingType.DailyRateBasedServiceCancellation]: BookingTypeGroup.Manual,
  [BookingType.Other]: BookingTypeGroup.Manual,
  [BookingType.RecurringFee]: BookingTypeGroup.Manual,
  [BookingType.RecurringFeeCancellation]: BookingTypeGroup.Manual,
  // Commission
  [BookingType.Commission]: BookingTypeGroup.Commission,
  [BookingType.CommissionCancellation]: BookingTypeGroup.Commission,
};

export function getGroupedBookingTypes(): Record<BookingTypeGroup, BookingType[]> {
  return Object.entries(bookingTypeGroups).reduce(
    (acc, [type, group]) => {
      acc[group] = acc[group] || [];
      acc[group].push(type as BookingType);
      return acc;
    },
    {} as Record<BookingTypeGroup, BookingType[]>
  );
}

export function getBookingTypeGroup(type: BookingType): BookingTypeGroup {
  return bookingTypeGroups[type];
}

export function getAllowedReferenceBookingTypes(type: BookingType): BookingType[] {
  const group = getBookingTypeGroup(type);
  const groupedTypes = getGroupedBookingTypes();
  const allTypes = Object.values(BookingType);
  switch (group) {
    case BookingTypeGroup.AdditionalFeature:
    case BookingTypeGroup.Service:
      return [type]; // should just reference itself
    case BookingTypeGroup.Payment:
    case BookingTypeGroup.Manual:
      return allTypes; // can reference any booking type
    default:
      return groupedTypes[group] || [];
  }
}

export function getCandidateBookingTypes(): BookingType[] {
  return [
    BookingType.Candidate,
    BookingType.CandidateCancellation,
    BookingType.CompensationAmount,
    BookingType.CompensationCap,
    BookingType.CompensationFloor,
    BookingType.CompensationMonthlyFloor,
    BookingType.CompensationMonthlyFloorOverpay,
    BookingType.CompensationCandidateByMonthlyFloor,
    BookingType.CompensationReplacement,
    BookingType.CandidateDiscount,
    BookingType.CandidateDiscountCancellation,
    BookingType.CompensationCandidateDiscount,
    BookingType.CompensationContingent,
  ];
}

export function getContingentBookingTypes(): BookingType[] {
  return [BookingType.Contingent];
}

export function getLicenseBookingTypes(): BookingType[] {
  return [
    BookingType.License,
    BookingType.LicenseDiscount,
    BookingType.LicenseDiscountCancellation,
    BookingType.LicenseCancellation,
    BookingType.LicenseCompensationAmount,
    BookingType.LicenseDiscountCompensationAmount,
    BookingType.MonthlyFloorPaidInAdvance,
  ];
}

// ── Add-on service booking-type registry ─────────────────────────────────────

export enum AddonServiceBillingRhythm {
  /**
   * One booking per organization per month.
   * The booking id is keyed by (organizationId, bookingType, bookingMonth) via
   * AddonFeeBookingFactory.createBookingId — a new type may only use this rhythm if a
   * single booking per org per month is semantically correct.
   */
  Monthly = "Monthly",
  /**
   * One booking per triggering event (pay-per-use).
   * The booking id is keyed by (organizationId, bookingType, eventId) via
   * generateCompositeKey — multiple bookings of the same type in a single month are expected.
   */
  UsageBased = "UsageBased",
}

export interface AddonServiceBookingTypeDefinition {
  /** How the booking is billed. Determines which booking id strategy is used. */
  readonly billingRhythm: AddonServiceBillingRhythm;
  /**
   * German label used in DATEV/accounting export descriptions so that modules sharing the same
   * GL account (e.g. Chat and CV-Parsing, both on SoftwareModule 4006/3906) remain distinguishable
   * in the export line items. Required for every add-on service type.
   */
  readonly descriptionLabel: string;
  /**
   * The cancellation booking type that reverses this fee, if any.
   * Present only on fee types; absent on the cancellation type itself.
   */
  readonly cancellationBookingType?: BookingType;
  readonly invoiceLineText?: string;
}

/**
 * Single source of truth for every add-on service booking type.
 *
 * When adding a new add-on service, add one entry here (fee type) and optionally a second one
 * (cancellation type). Everything else — getAddonBookingTypes(), getUsageBasedAddonBookingTypes(),
 * ADDON_BOOKING_TYPES, DEFAULT_ADDON_REVENUE_CATEGORIES, getAddonDescriptionLabel(),
 * AddonFeeBookingFactory id allowlists — is derived from this table automatically.
 * No other file needs to be touched for the billing-type registration itself.
 */
export const ADDON_SERVICE_BOOKING_REGISTRY: Partial<Record<BookingType, AddonServiceBookingTypeDefinition>> = {
  // Monthly flat fees
  [BookingType.ServiceChat]: {
    billingRhythm: AddonServiceBillingRhythm.Monthly,
    descriptionLabel: "Modul Chat",
    cancellationBookingType: BookingType.ServiceChatCancellation,
  },
  [BookingType.ServiceChatCancellation]: {
    billingRhythm: AddonServiceBillingRhythm.Monthly,
    descriptionLabel: "Modul Chat",
  },
  [BookingType.ServiceTalentPoolWebsite]: {
    billingRhythm: AddonServiceBillingRhythm.Monthly,
    descriptionLabel: "Modul Talentpool-Website",
    cancellationBookingType: BookingType.ServiceTalentPoolWebsiteCancellation,
  },
  [BookingType.ServiceTalentPoolWebsiteCancellation]: {
    billingRhythm: AddonServiceBillingRhythm.Monthly,
    descriptionLabel: "Modul Talentpool-Website",
  },
  // Pay-per-use fees
  [BookingType.ServiceCvParsing]: {
    billingRhythm: AddonServiceBillingRhythm.UsageBased,
    descriptionLabel: "Modul CV-Parsing",
    cancellationBookingType: BookingType.ServiceCvParsingCancellation,
  },
  [BookingType.ServiceCvParsingCancellation]: {
    billingRhythm: AddonServiceBillingRhythm.UsageBased,
    descriptionLabel: "Modul CV-Parsing",
  },
  [BookingType.ServiceDocuSealSigningSes]: {
    billingRhythm: AddonServiceBillingRhythm.UsageBased,
    descriptionLabel: "Modul Dokumentenunterschrift (SES)",
    invoiceLineText: "Digitale Unterschrift (SES)",
  },
  [BookingType.ServiceDocuSealSigningAes]: {
    billingRhythm: AddonServiceBillingRhythm.UsageBased,
    descriptionLabel: "Modul Dokumentenunterschrift (AES)",
    invoiceLineText: "Digitale Unterschrift (AES)",
  },
  [BookingType.ServiceDocuSealSigningQes]: {
    billingRhythm: AddonServiceBillingRhythm.UsageBased,
    descriptionLabel: "Modul Dokumentenunterschrift (QES)",
    invoiceLineText: "Digitale Unterschrift (QES)",
  },
  [BookingType.ServiceDocuSealIdVerification]: {
    billingRhythm: AddonServiceBillingRhythm.UsageBased,
    descriptionLabel: "Modul Dokumentenunterschrift (ID-Prüfung)",
  },
} satisfies Partial<Record<BookingType, AddonServiceBookingTypeDefinition>>;

/**
 * Add-on booking types billed as a recurring monthly fee.
 * Their booking id is composed of organization, booking type and booking month
 * (see AddonFeeBookingFactory.createBookingId), so a type may only be listed here if a
 * single booking per organization and month is correct.
 */
export function getAddonBookingTypes(): BookingType[] {
  return entries(ADDON_SERVICE_BOOKING_REGISTRY)
    .filter(([_, definition]) => definition.billingRhythm === AddonServiceBillingRhythm.Monthly)
    .map(([type]) => type as BookingType);
}

/**
 * Add-on booking types billed per use (pay-per-use).
 * One booking per triggering billing event, so these must not be mixed into
 * getAddonBookingTypes(), whose consumers assume one booking per month.
 */
export function getUsageBasedAddonBookingTypes(): BookingType[] {
  return entries(ADDON_SERVICE_BOOKING_REGISTRY)
    .filter(([_, definition]) => definition.billingRhythm === AddonServiceBillingRhythm.UsageBased)
    .map(([type]) => type as BookingType);
}

/** All booking types that end up on an add-on service invoice — monthly fees and pay-per-use alike. */
export function getAddOnInvoiceBookingTypes(): BookingType[] {
  return typedKeys(ADDON_SERVICE_BOOKING_REGISTRY);
}

/**
 * German label for a booking type in DATEV/accounting export descriptions.
 * Falls back to "Service" for types not in the registry (e.g. DailyRateBasedService, Other).
 */
export function getAddonDescriptionLabel(bookingType: BookingType): string {
  return ADDON_SERVICE_BOOKING_REGISTRY[bookingType]?.descriptionLabel ?? "Service";
}

export function getAddonInvoiceLineText(bookingType: BookingType): string | null {
  return ADDON_SERVICE_BOOKING_REGISTRY[bookingType]?.invoiceLineText ?? null;
}

export function getCommissionBookingTypes(): BookingType[] {
  return [BookingType.Commission, BookingType.CommissionCancellation];
}

export function getCreditBalanceSettlementBookingTypes(): BookingType[] {
  return [BookingType.CreditBalanceSettlement, BookingType.CreditBalanceSettlementCancellation];
}

export function getUserAccountBookingTypes(): BookingType[] {
  return [BookingType.UserAccount, BookingType.UserAccountCancellation];
}

export function isCandidateBookingType(type: BookingType): boolean {
  return getCandidateBookingTypes().includes(type);
}

export function isLicenseBookingType(type: BookingType): boolean {
  return getLicenseBookingTypes().includes(type);
}

export function isContingentBookingType(type: BookingType): boolean {
  return getContingentBookingTypes().includes(type);
}

export function isAddonBookingType(type: BookingType): boolean {
  return getAddonBookingTypes().includes(type);
}

export function isUsageBasedAddonBookingType(type: BookingType): boolean {
  return getUsageBasedAddonBookingTypes().includes(type);
}

export function isCommissionBookingType(type: BookingType): boolean {
  return getCommissionBookingTypes().includes(type);
}

export function isCreditBalanceSettlementBookingType(type: BookingType): boolean {
  return getCreditBalanceSettlementBookingTypes().includes(type);
}

export function isUserAccountBookingType(type: BookingType): boolean {
  return getUserAccountBookingTypes().includes(type);
}

export function getBookingTypeSign(bookingType: BookingType): "+" | "-" | "?" {
  switch (bookingType) {
    case BookingType.IncomingPaymentCancellation:
    case BookingType.CreditBalanceSettlementCancellation:
    case BookingType.CreditNote:
    case BookingType.LicenseDiscount:
    case BookingType.CandidateDiscount:
    case BookingType.CandidateCancellation:
    case BookingType.LicenseCancellation:
    case BookingType.CompensationCap:
    case BookingType.CompensationCandidateByMonthlyFloor:
    case BookingType.CompensationReplacement:
    case BookingType.CompensationContingent:
    case BookingType.ServiceChatCancellation:
    case BookingType.ServiceCvParsingCancellation:
    case BookingType.ServiceTalentPoolWebsiteCancellation:
    case BookingType.Commission:
    case BookingType.DailyRateBasedServiceCancellation:
    case BookingType.UserAccountCancellation:
    case BookingType.RecurringFeeCancellation:
      return "+";
    case BookingType.License:
    case BookingType.LicenseDiscountCancellation:
    case BookingType.MonthlyFloorPaidInAdvance:
    case BookingType.Contingent:
    case BookingType.CandidateTransfer:
    case BookingType.UserAccount:
    case BookingType.ServiceLingoking:
    case BookingType.ServiceBarmer:
    case BookingType.DailyRateBasedService:
    case BookingType.Other:
    case BookingType.RecurringFee:
    case BookingType.Candidate:
    case BookingType.CompensationFloor:
    case BookingType.CompensationMonthlyFloor:
    case BookingType.CompensationMonthlyFloorOverpay:
    case BookingType.CandidateDiscountCancellation:
    case BookingType.ServiceChat:
    case BookingType.ServiceCvParsing:
    case BookingType.ServiceDocuSealSigningSes:
    case BookingType.ServiceDocuSealSigningAes:
    case BookingType.ServiceDocuSealSigningQes:
    case BookingType.ServiceDocuSealIdVerification:
    case BookingType.ServiceTalentPoolWebsite:
    case BookingType.CommissionCancellation:
    case BookingType.IncomingPayment:
    case BookingType.CreditBalanceSettlement:
      return "-";
    case BookingType.CompensationCandidateDiscount:
    case BookingType.CompensationAmount:
    case BookingType.LicenseCompensationAmount:
    case BookingType.LicenseDiscountCompensationAmount:
      return "?";
  }
}

export function getSupportedManualBookingTypes(): BookingType[] {
  // CandidateTransfer, UserAccount, ServiceLingoking, and ServiceBarmer are created
  // automatically by the system and are intentionally not available for manual entry.
  return [
    BookingType.License,
    BookingType.LicenseDiscount,
    BookingType.LicenseDiscountCancellation,
    BookingType.LicenseCancellation,
    BookingType.LicenseCompensationAmount,
    BookingType.LicenseDiscountCompensationAmount,
    BookingType.Candidate,
    BookingType.CandidateDiscount,
    BookingType.CandidateDiscountCancellation,
    BookingType.CandidateCancellation,
    BookingType.CompensationAmount,
    BookingType.CompensationCandidateDiscount,
    BookingType.Contingent,
    BookingType.DailyRateBasedService,
    BookingType.DailyRateBasedServiceCancellation,
    BookingType.CreditNote,
    BookingType.ServiceChatCancellation,
    BookingType.ServiceCvParsingCancellation,
    BookingType.ServiceTalentPoolWebsiteCancellation,
    BookingType.CommissionCancellation,
    BookingType.UserAccountCancellation,
    BookingType.Other,
    BookingType.RecurringFeeCancellation,
    // BookingType.RecurringFee, // created only via the contract's recurring fees section, not ad-hoc
    // BookingType.CandidateTransfer,
    // BookingType.UserAccount,
    // BookingType.ServiceLingoking,
    // BookingType.ServiceBarmer,
  ];
}

export function isCancellationBookingType(bookingType: BookingType): boolean {
  const cancellationBookingTypes = [
    BookingType.CandidateCancellation,
    BookingType.LicenseCancellation,
    BookingType.LicenseDiscountCancellation,
    BookingType.CandidateDiscountCancellation,
    BookingType.ServiceChatCancellation,
    BookingType.ServiceCvParsingCancellation,
    BookingType.ServiceTalentPoolWebsiteCancellation,
    BookingType.CommissionCancellation,
    BookingType.DailyRateBasedServiceCancellation,
    BookingType.UserAccountCancellation,
    BookingType.RecurringFeeCancellation,
    BookingType.IncomingPaymentCancellation,
    BookingType.CreditBalanceSettlementCancellation,
  ];
  return cancellationBookingTypes.includes(bookingType);
}

const requiredReferenceBookingTypes: Record<BookingType, BookingType[]> = {
  [BookingType.Candidate]: [],
  [BookingType.CandidateCancellation]: [BookingType.Candidate],
  [BookingType.CandidateDiscountCancellation]: [BookingType.CandidateDiscount],
  [BookingType.CompensationAmount]: [BookingType.Candidate],
  [BookingType.CompensationCandidateDiscount]: [BookingType.CandidateDiscount],
  [BookingType.CandidateDiscount]: [BookingType.Candidate],
  [BookingType.CompensationCap]: [],
  [BookingType.CompensationFloor]: [],
  [BookingType.CompensationMonthlyFloor]: [],
  [BookingType.CompensationMonthlyFloorOverpay]: [],
  [BookingType.CompensationCandidateByMonthlyFloor]: [BookingType.Candidate],
  [BookingType.CompensationReplacement]: [BookingType.Candidate],
  [BookingType.CompensationContingent]: [BookingType.Candidate],
  [BookingType.Contingent]: [],
  [BookingType.License]: [],
  [BookingType.LicenseCancellation]: [BookingType.License],
  [BookingType.LicenseDiscountCancellation]: [BookingType.LicenseDiscount],
  [BookingType.LicenseDiscount]: [BookingType.License],
  [BookingType.LicenseCompensationAmount]: [BookingType.License],
  [BookingType.LicenseDiscountCompensationAmount]: [BookingType.LicenseDiscount],
  [BookingType.MonthlyFloorPaidInAdvance]: [],
  [BookingType.CandidateTransfer]: [],
  [BookingType.UserAccount]: [],
  [BookingType.UserAccountCancellation]: [BookingType.UserAccount],
  [BookingType.ServiceLingoking]: [],
  [BookingType.ServiceBarmer]: [],
  [BookingType.DailyRateBasedService]: [],
  [BookingType.DailyRateBasedServiceCancellation]: [BookingType.DailyRateBasedService],
  [BookingType.IncomingPayment]: [],
  [BookingType.IncomingPaymentCancellation]: [BookingType.IncomingPayment],
  [BookingType.CreditBalanceSettlement]: [],
  [BookingType.CreditBalanceSettlementCancellation]: [BookingType.CreditBalanceSettlement],
  [BookingType.CreditNote]: [],
  [BookingType.ServiceChat]: [],
  [BookingType.ServiceChatCancellation]: [BookingType.ServiceChat],
  [BookingType.ServiceCvParsing]: [],
  [BookingType.ServiceDocuSealSigningSes]: [],
  [BookingType.ServiceDocuSealSigningAes]: [],
  [BookingType.ServiceDocuSealSigningQes]: [],
  [BookingType.ServiceDocuSealIdVerification]: [],
  [BookingType.ServiceCvParsingCancellation]: [BookingType.ServiceCvParsing],
  [BookingType.ServiceTalentPoolWebsite]: [],
  [BookingType.ServiceTalentPoolWebsiteCancellation]: [BookingType.ServiceTalentPoolWebsite],
  [BookingType.Other]: [],
  [BookingType.RecurringFee]: [],
  [BookingType.RecurringFeeCancellation]: [BookingType.RecurringFee],
  [BookingType.Commission]: [],
  [BookingType.CommissionCancellation]: [BookingType.Commission],
};

export function getRequiredReferenceBookingTypes(bookingType: BookingType): BookingType[] {
  return requiredReferenceBookingTypes[bookingType] ?? [];
}

const candidateReferenceRequiredBookingTypes: BookingType[] = [
  BookingType.Candidate,
  BookingType.CandidateCancellation,
  BookingType.CompensationAmount,
  BookingType.CompensationCandidateDiscount,
  BookingType.CandidateDiscount,
  BookingType.CompensationCandidateByMonthlyFloor,
  BookingType.CompensationReplacement,
  BookingType.CompensationContingent,
];

export function requiresReferenceToCandidate(bookingType: BookingType): boolean {
  return candidateReferenceRequiredBookingTypes.includes(bookingType);
}
